import * as React from 'react';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import StarPicker from '@liveauctioneers/caterwaul-components/lib/StarRating/StarPicker';
import styled from 'styled-components';

type Props = {
    className?: string;
    onChange: any;
};

const RatingInput = (props: Props) => {
    const { className, onChange } = props;
    const [hoverRating, setHoverRating] = React.useState(0);
    const [rating, setRating] = React.useState(0);

    const onClick = React.useCallback(
        (v: number) => {
            onChange(v);
            setRating(v);
        },
        [onChange]
    );

    return (
        <RatingContainer className={className}>
            <StarPicker
                onClick={onClick}
                onHover={setHoverRating}
                stars={5}
            />
            <RatingCopy className="ratingCopy">
                {(rating > 0 || hoverRating > 0) && (
                    <FormattedMessage id={`review_page.review_copy._${hoverRating ? hoverRating : rating}`} />
                )}
            </RatingCopy>
        </RatingContainer>
    );
};

export default RatingInput;

const RatingContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 8px; /* TODO: should be controlled at parent */

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        flex-direction: column;
    }
`;

const RatingCopy = styled.div`
    color: ${({ theme }) => theme.colors.grey100};
    font-family: ${({ theme }) => theme.typography.fontPrimary};
    letter-spacing: 0.6px;
    float: left;
    margin: auto 5px; /* TODO: should be controlled at parent */

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        margin-top: 10px; /* TODO: should be controlled at parent */
    }
`;
